import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { CourseModel } from '@generativ/much-smarter-models';
import { Subscription } from 'rxjs';
import { CourseService } from '../../../shared/course.service';
import { DashboardService } from '../../../pages/dashboard/dashboard.service';
import { NgClass, DecimalPipe } from '@angular/common';

@Component({
    selector: 'app-choose-the-country',
    templateUrl: './choose-the-country.component.html',
    styleUrls: ['./choose-the-country.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgClass, DecimalPipe]
})
export class ChooseTheCountryComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  selectedCountry: string;
  hoverUS = false;
  hoverUK = false;
  games: any[];

  constructor(
    private router: Router,
    private courseService: CourseService,
    private dashboardService: DashboardService
  ) {
    this.selectedCountry = localStorage.getItem('selectedCountry');
    const selectedCourseId = localStorage.getItem('selectedCourse');
    if (this.selectedCountry && selectedCourseId) {
      this.router.navigate(['/']);
    }
    this.courseService.fetchAllCourses();
  }

  ngOnInit() {
    this.subscriptions.add(
      this.courseService.courses.subscribe((courses: CourseModel[]) => {
        // If country already selected filter courses to match country
        if (this.selectedCountry) {
          this.games = courses.filter(
            (course) => course.country === this.selectedCountry
          );
        } else {
          const activeCountries = new Set(
            courses.reduce((acc, elem) => [...acc, elem.country], [])
          );
          if (activeCountries.size === 1) {
            this.chooseTheCountry(Array.from(activeCountries)[0]);
          }
          this.games = courses;
        }
        this.games.forEach(game => {
          game.isHover = false;
          this.dashboardService
            .getStudentCourseProgress(game.id)
            .subscribe((progress: number) => {
              game.progress = !progress ? 0 : progress * 100;
            });
        });
      })
    );
  }

  checkIfCountry(country): boolean {
    for (const game of this.games) {
      if (game.country === country) {
        return true;
      }
    }
    return false;
  }

  chooseTheCountry(country) {
    this.selectedCountry = country;
    localStorage.setItem('selectedCountry', this.selectedCountry);
    if (this.games) {
      this.games = this.games.filter(
        (game) => game.country === this.selectedCountry
      );
    }
  }

  chooseTheGame(id) {
    localStorage.setItem('selectedCourse', id);
    this.router.navigate(['/']);
  }

  getCountryImage(title): string {
    const BASE_IMAGE_URL = 'assets/images/courses/';
    if (
      /.*UK.*/gi.test(title) &&
      (/.*SAT.*/gi.test(title) || /.*1.*/gi.test(title))
    ) {
      return BASE_IMAGE_URL + 'MuchSmarter UK 1.svg';
    }
    if (
      /.*UK.*/gi.test(title) &&
      (/.*CATCH.*/gi.test(title) || /.*2.*/gi.test(title))
    ) {
      return BASE_IMAGE_URL + 'MuchSmarter UK 2.svg';
    }
    if (/.*ACT.*/gi.test(title)) {
      return BASE_IMAGE_URL + 'MuchSmarter ACT.svg';
    }
    if (/.*SAT.*/gi.test(title)) {
      return BASE_IMAGE_URL + 'MuchSmarter SAT.svg';
    }
    if (/.*Math.*1.*/gi.test(title)) {
      return BASE_IMAGE_URL + 'MuchSmarter Math 1.svg';
    }
    if (/.*Math.*2.*/gi.test(title)) {
      return BASE_IMAGE_URL + 'MuchSmarter Math 2.svg';
    }
    if (/.*Math.*3.*/gi.test(title)) {
      return BASE_IMAGE_URL + 'MuchSmarter Math 3.svg';
    }
    if (/.*Math.*4.*/gi.test(title)) {
      return BASE_IMAGE_URL + 'MuchSmarter Math 4.svg';
    }
    if (/.*Accelerator Programme.*/gi.test(title)) {
      return BASE_IMAGE_URL + 'MuchSmarter Accelerator Programme.svg';
    }
    if (/.*UK \- GCSE.*/gi.test(title)) {
      return BASE_IMAGE_URL + 'MuchSmarter UK GCSE.svg';
    }
    return null;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
